<template>
  <div class="notify-group">
    <Card style="padding-bottom: 40px">
      <Button @click="addNotifyGroup" type="primary">添加</Button>
      <Table
          :loading="notifyGroupLoading"
          :columns="columns"
          :data="data"
          :border="true"
          :highlight-current-row="true"
          style="margin-top: 10px"
      >
        <template #action="{ row, index }">
          <el-button size="small" type="text" @click="getNotifyGroupById(row)">编辑</el-button>
          <el-button size="small" type="text" @click="deleteNotifyGroup(row)">删除</el-button>
        </template>
      </Table>
    </Card>
    <Modal v-model="notifyGroupModal"
           :title="isEdit ? '修改' : '添加'"
    >
      <Form :model="notifyGroupFrom" :rules="notifyGroupRules" :label-width="100" ref="notifyGroupFrom">
        <FormItem label="小组名称" prop="name">
          <Input v-model="notifyGroupFrom.name"></Input>
        </FormItem>
        <FormItem label="小组人员" prop="users">
          <Select transfer v-model="notifyGroupFrom.users" multiple filterable>
            <Option v-for="item in userList" :value="item.userId" :key="item.id">{{ item.username }}</Option>
          </Select>
        </FormItem>
        <FormItem label="区县" prop="countyId">
          <Select transfer v-model="notifyGroupFrom.countyId">
            <Option v-for="item in countysList" :value="item.indexCode" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button @click="notifyGroupModal = false">取消</Button>
        <Button v-if="!isEdit" type="primary" :loading="addLoading" @click="addGroup">确定</Button>
        <Button v-else type="primary" :loading="addLoading" @click="editGroup">修改</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "notifyGroup",
  data() {
    return {
      countysList: [],
      userList: [],
      notifyGroupModal: false,
      notifyGroupLoading: false,
      addLoading: false,
      isEdit: false,
      columns: [
        {
          title: 'id',
          key: 'id',
          align: 'center',
        },
        {
          title: '通知小组',
          key: 'name',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      notifyGroupFrom: {
        name: '',
        countyId: 0,
        users: ''
      },
      notifyGroupRules: {
        name: [
          { required: true, message: '请输入通知小组', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.getNotifyGroup()
    this.getCountysList()
    this.getUserList()
  },
  methods: {
    getCountysList() {
      this.$http.get('/api/getAllCountys').then(res => {
        this.countysList = res.data
      })
    },
    getUserList(){
      this.$http.get('/api/system/cscpUserDetailsOr').then(res => {
        // console.log(res)
        this.userList = res.data.data
      })
    },
    addGroup() {
      this.$refs.notifyGroupFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          var str = this.notifyGroupFrom.users
          let params ={
            name: this.notifyGroupFrom.name,
            countyId: this.notifyGroupFrom.countyId,
            users: str.toString()
          }
          this.$http.post('/api/noticeGroups', params).then(res => {
            this.addLoading = false
            this.notifyGroupModal = false
            this.$Message.success('添加成功')
            this.getNotifyGroup()
          })
        } else {
          return false
        }
      })
    },
    getNotifyGroupById(row) {
      let id = row.id
      this.$http.get(`/api/noticeGroups/${ id }`).then(res => {
        if (res.status === 200) {
          this.isEdit = true
          this.notifyGroupFrom = res.data
          this.notifyGroupFrom.users = res.data.users.split(',')
          this.notifyGroupFrom.countyId = res.data.countyId.toString()
          this.notifyGroupModal = true
        } else {
          this.$Message.error('获取数据失败')
        }
      })
    },
    editGroup() {
      this.$refs.notifyGroupFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          var str = this.notifyGroupFrom.users
          let params ={
            ...this.notifyGroupFrom,
          }
          params.name = this.notifyGroupFrom.name
          params.countyId = this.notifyGroupFrom.countyId
          params.users = str.toString()
          // console.log(params)
          this.$http.put(`/api/noticeGroups`, params).then(res => {
            if (res.status === 200) {
              this.addLoading = false
              this.notifyGroupModal = false
              this.$Message.success('修改成功')
              this.getNotifyGroup()
            } else {
              this.$Message.error('修改失败')
            }
          })
        } else {
          return false
        }
      })
    },
    addNotifyGroup() {
      this.notifyGroupModal = true
      this.isEdit = false
      this.notifyGroupFrom = {}
    },
    getNotifyGroup() {
      this.$http.get('/api/noticeGroups').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
        }
      })
    },
    deleteNotifyGroup(row){
      this.$http.delete(`/api/noticeGroups/${row.id}`).then(res => {
        console.log(res)
        this.getNotifyGroup()
      })
    }
  }
}
</script>

<style scoped>

</style>
